/**
 * Chart color palette based on brand colors.
 * Light, airy feel - soft blues, warm terracotta, clean grays.
 */
export const CHART_COLORS = {
  // Soft, lighter variants of brand colors
  softBlue: '#5B9BD5',
  mediumBlue: '#7AB5E0',
  lightBlue: '#9CC9E8',
  softTerracotta: '#E08B6A',
  lightTerracotta: '#EBA890',
  mutedGreen: '#8FB86B',
  lightGray: '#E5E5E5',
  mediumGray: '#D9D9D9',
  softGray: '#C9C9C9',
} as const;

export const DEAL_FUNNEL_STATUS_COLORS: Record<string, string> = {
  Estimate: CHART_COLORS.softBlue,
  Draft: CHART_COLORS.softBlue,
  'In Review': CHART_COLORS.softBlue,
  Bidding: CHART_COLORS.softBlue,
  'Bid Review': CHART_COLORS.softBlue,
  'In Diligence': CHART_COLORS.softBlue,
  Executed: CHART_COLORS.softBlue,
  Completed: CHART_COLORS.softBlue,
};

export const DEPLOYMENT_TYPE_COLORS: Record<string, string> = {
  CI: CHART_COLORS.softBlue,
  COMMUNITY_SOLAR: CHART_COLORS.mutedGreen,
  Community: CHART_COLORS.mutedGreen,
  UTILITY: CHART_COLORS.softTerracotta,
  Utility: CHART_COLORS.softTerracotta,
};
